import React from 'react';
import { connect } from 'react-redux';
import { RootState } from '../../models/RootState';
import './ExchOpenBets.scss';
import { UserBet } from '../../models/ExchBetSlip';
import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { useTranslation } from '../../hooks/useTranslation';

type StoreProps = {
  openBets: UserBet[];
};


const ExchOpenBets: React.FC<StoreProps> = (props) => {
  const { t } = useTranslation();
  const { openBets } = props;

  return (
    <div className="open-bets-ctn  open-bts-dup">
      <Table className="exch-open-bets-table">
        <TableHead className="open-bets-table-head">
          <TableRow className="open-bets-table-row">
            <TableCell className="market-cell ">{t("sports.market")}</TableCell>
            <TableCell className="odds-cell" align="right">
              {t("sports.odds")}
            </TableCell>
            <TableCell className="stake-cell" align="right">
              {t("sports.stake")}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody className="open-bets-table-body">
          {openBets.map((bet, idx) => (
            <TableRow
              key={'row' + idx}

              className="open-bets-table-row"
            >
              <TableCell
                key={'market-cell-row' + idx}
                className={
                  bet.betType === 'BACK'
                    ? 'back-bet open-bets-table-row'
                    : 'lay-bet open-bets-table-row'
                }
              >
                {bet.marketType === "BOOKMAKER" ? bet.marketName : bet.marketType} {" - "} {bet.runnerName}
              </TableCell>
              <TableCell
                key={'odds-cell-row' + idx}
                align="right"
                className={
                  bet.betType === 'BACK'
                    ? 'back-bet open-bets-table-row'
                    : 'lay-bet open-bets-table-row'
                }
              >
                {bet.marketType === "FANCY"
                  ? Number(bet.sessionOutcome).toFixed(0)
                  : bet.oddValue.toFixed(2)}
              </TableCell>
              <TableCell
                key={'stake-cell-row' + idx}
                align="right"
                className={
                  bet.betType === 'BACK'
                    ? 'back-bet open-bets-table-row'
                    : 'lay-bet open-bets-table-row'
                }
              >
                {(bet?.stakeAmount).toFixed(0)}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    openBets: state.exchBetSlip.openBets,
  };
};

export default connect(mapStateToProps)(ExchOpenBets);
